export default __webpack_public_path__ + "static/media/jspic.5a908e0c.png";